module.exports = __webpack_public_path__ + "static/media/zuk_farm.ec858c56.jpg";